export default __webpack_public_path__ + "static/slide-2-5a7597e29c34abedc15e7d766e918cd8.jpg";